import React, { useState, useEffect } from "react";
import styles from "./ExpiredPlanBanner.module.scss";
import logo from "../../../../assets/svg/logo-banner.svg";
import { useUser } from "../../../../providers/user.provider";
import { useWindowDimensions } from "../../../../services/widthCheck.service";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

interface Style {
  margin?: number;
  plans?: boolean;
  mytol?: boolean;
}

const ExpiredPlanSubscriptionBanner = (props: Style) => {
  const [close, setClose] = useState<boolean>(false);
  const { width } = useWindowDimensions();

  const { exPlanBanner, setExPlanBanner, user } = useUser();
  const navigate = useNavigate();

  const handleClickClose = () => {
    setClose(false);
    setExPlanBanner(false);
    // console.log('[ExpiredPlanSubscriptionBanner] Banner closed by user (only for current session)');
  };

  const handleViewPlans = () => {
    navigate("/olink/premium");
  };

  useEffect(() => {
    // console.log('[ExpiredPlanSubscriptionBanner] Effect triggered', {
    //   userId: user?.id,
    //   exPlanBanner,
    //   access: user?.access,
    //   accessed_at: user?.accessed_at,
    //   role: user?.role,
    //   accessRoles: user?.accessRoles
    // });

    // Wait until user data is loaded
    if (!user || !user.id) {
      // console.log('[ExpiredPlanSubscriptionBanner] User not loaded, hiding banner');
      setClose(false);
      return;
    }

    // User closed the banner manually in current session only
    if (!exPlanBanner) {
      // console.log('[ExpiredPlanSubscriptionBanner] Banner closed manually by user in current session');
      setClose(false);
      return;
    }

    const accessedAt = new Date(user?.accessed_at || "");
    const currentDate = new Date();

    // console.log('[ExpiredPlanSubscriptionBanner] Date comparison:', {
    //   accessedAt: accessedAt.toISOString(),
    //   currentDate: currentDate.toISOString(),
    //   isExpired: accessedAt < currentDate
    // });

    // Don't show for admins and managers
    const isAdmin = (user?.role === "admin" || (user?.accessRoles && user?.accessRoles.some(role => [ 'superadmin', 'admin' ].includes(role.title))));
    const isManager = (user?.role === "manager" || (user?.accessRoles && user?.accessRoles.some(role => [ 'moderator' ].includes(role.title))));

    if (isAdmin || isManager) {
      // console.log('[ExpiredPlanSubscriptionBanner] User is admin or manager, hiding banner');
      setClose(false);
      return;
    }

    // Don't show for regular (free) users - they don't have subscriptions to expire
    const isRegularUser = user?.access === "regular";
    if (isRegularUser) {
      // console.log('[ExpiredPlanSubscriptionBanner] User has regular access, hiding banner');
      setClose(false);
      return;
    }

    // Show banner if subscription has expired (accessed_at < currentDate)
    // This applies to premium, pro, and lifetime subscriptions that have ended
    const hasExpiredSubscription = accessedAt < currentDate;

    if (hasExpiredSubscription) {
      // console.log('[ExpiredPlanSubscriptionBanner] Subscription expired, showing banner');
      setClose(true);
    } else {
      // console.log('[ExpiredPlanSubscriptionBanner] Subscription is active, hiding banner');
      setClose(false);
    }
  }, [exPlanBanner, user, setExPlanBanner]);

  // console.log('[ExpiredPlanSubscriptionBanner] Rendering, close state:', close);

  return (
    <>
      {close ? (
        <div className={styles.ep_banner}>
          <div className={styles.banner__inner}>
            {width >= 985 ? (
              <img
                width={114}
                height={45}
                src={logo}
                alt="the only link logo"                
              />
            ) : null}
            <p className={styles.banner__text}>
              Heads up - your last payment didn't go through. We'll automatically try again over the next 15 days. To make sure you don't lose access to your premium features (or any data), just update your payment details when you get a chance!
            </p>
            <button onClick={handleViewPlans}>View Plans</button>
          </div>

          <button
            style={{
              background: "transparent",
              border: "none",
              color: "#fff",
              marginLeft: "7px",
              minWidth: "14px",
              height: "24px",
            }}
            onClick={handleClickClose}
          >
            <CloseIcon />
          </button>
        </div>
      ) : null}
    </>
  );
};

export default ExpiredPlanSubscriptionBanner;
